import styles from './key-hint.module.css'

interface KeyHintProps {
  /** The binding's label, e.g. `E` or `X`. Nothing renders when it's empty (unbound). */
  readonly label: string
  /** `key`: a keyboard keycap. `button`: a round gamepad button. */
  readonly variant: 'key' | 'button'
}

/** Which key or button to press, drawn like the physical thing. */
export function KeyHint({ label, variant }: KeyHintProps) {
  if (label === '') return null
  return <kbd class={variant === 'key' ? styles.key : styles.button}>{label}</kbd>
}
